import React from "react";
import { TOPBAR_HEIGHT } from "../Layout/TopNavbar";

export default function Dashboard({ user, onLogout }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f4f6fb",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <header
        style={{
          height: TOPBAR_HEIGHT,
          minHeight: TOPBAR_HEIGHT,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 24px",
          background: "linear-gradient(135deg, #0d9488, #14b8a6)",
          color: "#ffffff",
          boxShadow: "0 4px 14px rgba(13, 148, 136, 0.25)",
          position: "sticky",
          top: 0,
          zIndex: 50,
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            fontSize: 20,
            fontWeight: 800,
            letterSpacing: "0.2px",
          }}
        >
          Softvolute Buildcon LLP
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <span style={{ fontSize: 14, fontWeight: 700 }}>
            Welcome, {user?.name || "Admin"}
            <span
              style={{
                marginLeft: 8,
                padding: "2px 10px",
                borderRadius: 999,
                background: "rgba(255, 255, 255, 0.22)",
                fontSize: 12,
                fontWeight: 600,
                textTransform: "capitalize",
              }}
            >
              {user?.role || "employee"}
            </span>
          </span>

          <button
            type="button"
            onClick={onLogout}
            style={{
              border: "none",
              borderRadius: 999,
              padding: "8px 18px",
              background: "#ffffff",
              color: "#0d9488",
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </div>
      </header>

      <main style={{ padding: 35 }}>
        <h1>Welcome, {user?.name || "Employee"}</h1>
        <p>Softvolute ERP Dashboard</p>
        <p>Role: {user?.role || "employee"}</p>
      </main>
    </div>
  );
}
